$(document).ready(function () {
    //header menu
    $('.header-buyers__top').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.header-top').toggleClass('visible-buyers');
    });
    $('.header-city-top').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.header-top').toggleClass('visible-city');
    });
    $('.header-phone__top').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.header-top').toggleClass('visible-phones');
    });

    $('body').on('click', function (e) {
        if ($('.header-top').hasClass('visible-buyers')) {
            if (!$('.header-buyers__bottom').is(e.target) && $('.header-buyers__bottom').has(e.target).length === 0 &&
                !$('.header-buyers__top').is(e.target) && $('.header-buyers__top').has(e.target).length === 0) {
                $('.header-top').removeClass('visible-buyers');
            }
        }

        if ($('.header-top').hasClass('visible-city')) {
            if (!$('.header-city-bottom').is(e.target) && $('.header-city-bottom').has(e.target).length === 0 &&
                !$('.header-city-top').is(e.target) && $('.header-city-top').has(e.target).length === 0 || $('.header-city-bottom__btn').is(e.target)) {
                $('.header-top').removeClass('visible-city');
            }
        }

        if ($('.header-top').hasClass('visible-phones')) {
            if (!$('.header-phone-bottom').is(e.target) && $('.header-phone-bottom').has(e.target).length === 0 &&
                !$('.header-phone__top').is(e.target) && $('.header-phone__top').has(e.target).length === 0 || $('.header-phone-bottom__btn').is(e.target)) {
                $('.header-top').removeClass('visible-phones');
            }
        }
        if ($('.header-catalog').hasClass('visible-catalog')) {
            if (!$('.header-catalog-menu').is(e.target) && $('.header-catalog-menu').has(e.target).length === 0 &&
                !$('.header-catalog__btn').is(e.target) && $('.header-catalog__btn').has(e.target).length === 0) {
                $('.header-catalog').removeClass('visible-catalog');
                $('.page-overlay-small').removeClass('show');
            }
        }
    });
    //popup disable drag
    Fancybox.bind('.header-phone-bottom__btn', {
        dragToClose: false
    });
    Fancybox.bind('.header-phone-mob', {
        dragToClose: false
    });
    Fancybox.bind('.footer__callback-btn', {
        dragToClose: false
    });
    Fancybox.bind('.header-city-bottom__btn--change-city', {
        dragToClose: false
    });
    Fancybox.bind('.product-details-delivery-city__btn', {
        dragToClose: false
    });
    Fancybox.bind('.personal-data-accordion-login__btn--phone', {
        dragToClose: false
    });
    Fancybox.bind('.personal-data-accordion-login__btn--email', {
        dragToClose: false
    });
    Fancybox.bind('.personal-account-wishlist__add', {
        dragToClose: false
    });
    Fancybox.bind('.personal-account-wishlist-table__edit-btn', {
        dragToClose: false
    });
    Fancybox.bind('.personal-account-wishlist-table__del-btn', {
        dragToClose: false
    });
    Fancybox.bind('.header-bottom-link--account', {
        dragToClose: false,
    });
    Fancybox.bind('.login-popup-soc__registration', {
        dragToClose: false,
    });
    Fancybox.bind('.login-popup-soc__login', {
        dragToClose: false,
    });
    Fancybox.bind('.login-popup__forgot-pass', {
        dragToClose: false,
    });
    Fancybox.bind('.forgotpass-popup__remember-pass', {
        dragToClose: false,
    });
    Fancybox.bind('.forgotpass-popup__registration', {
        dragToClose: false,
    });
    Fancybox.bind('.product-view__click-btn', {
        dragToClose: false,
    });
    Fancybox.bind('.product-view__inform', {
        dragToClose: false,
    });
    // Fancybox.bind('.leave-feedback-form__submit', {
    //     dragToClose: false,
    // });
    Fancybox.bind('.wishlist-page__add', {
        on: {
            done: (fancybox, slide) => {
              let productPopupLeft = new Swiper('.product-details-popup__photos-small', {
                  slidesPerView: 7,
                  spaceBetween: 10,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  direction: 'vertical',
              });
              let productsPopupRight = new Swiper('.product-details-popup__photos-big', {
                  thumbs: {
                      swiper: productPopupLeft
                  },
                  navigation: {
                      nextEl: '.product-details-popup__photos-big-wrapper .slider-button-next',
                      prevEl: '.product-details-popup__photos-big-wrapper .slider-button-prev',
                  },
                  pagination: {
                      el: '.product-details-popup__photos-big-wrapper .swiper-pagination',
                      type: 'bullets',
                      clickable: true
                  }
              });
            },
          },
        dragToClose: false,
    });
    Fancybox.bind('.main-popup-btn', {
        dragToClose: false,
    });
    $('.login-popup-soc__registration, .login-popup__forgot-pass, .login-popup-soc__login, .forgotpass-popup__remember-pass, .forgotpass-popup__registration').on('click', function(e){
        Fancybox.close();
    })
    //popup city switcher
    $('.city-popup__list button').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).parent().siblings().find('button').removeClass('active');
            $('.header-city-top').text($(this).text());
            $('.header-city-bottom__title span').text($(this).text());
            $('.city-popup-search select').val('');
            $('.city-popup-search input').val('');
        }
    });

    // custom scroll
    $('.aside-cart__list').mCustomScrollbar({ theme: "dark-3" });
    $('.bottom-nav-cart__main').mCustomScrollbar({ theme: "dark-3" });
    $('.bottom-nav-account__main').mCustomScrollbar({ theme: "dark-3" });

    // change city in header
    $('.city-popup-search select').on('change', function () {
        if ($(this).val().length) {
            $('.header-city-top').text($(this).val().replace(/ .*/, ''));
            $('.header-city-bottom__title span').text($(this).val().replace(/ .*/, ''));
            $('.city-popup__list button').each(function () {
                $(this).removeClass("active");
            })
        } else {
            $('.header-city-top').text($('.city-popup__list button.active').text());
            $('.header-city-bottom__title span').text($('.city-popup__list button.active').text());
        }
    });
    //phone mask
    function runInputMask() {
        let telInput = $('.form-field input[type="tel"]');
        telInput.inputmask({
            mask: ["+38 (999) 999-99-99",
                "+9[9][9][9][9][9][9][9][9][9]"],
            keepStatic: !0,
            showMaskOnHover: false
        });
    };

    runInputMask();

     $('body').on('click', function (e) {
        if ($('.bottom-nav-cart-empty').hasClass('active')) {
            if (!$('.bottom-nav-cart-empty').is(e.target) && $('.bottom-nav-cart-empty').has(e.target).length === 0 &&
                !$('.bottom-nav__item--cart').is(e.target) && $('.bottom-nav__item--cart').has(e.target).length === 0 || $('.bottom-nav-cart-empty__close').is(e.target)) {
                $('.bottom-nav-cart-empty').removeClass('active');
                $('.page-overlay').removeClass('show');
                $('.bottom-nav__item--cart').removeClass('active');
                $('body').removeClass('overflow');
            }
        }
    });


    //swiper slider
    const promoSlider = new Swiper('.promo-slider .swiper-container', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 500,
        autoplay: {
            delay: 7000,
        },
        navigation: {
            nextEl: '.promo-slider .slider-button-next',
            prevEl: '.promo-slider .slider-button-prev',
        },
    });
    //categories slider

    const categoriesSlider = new Swiper('.main-categories__slider .swiper-container', {
        loop: true,
        spaceBetween: 4,
        slidesPerView: 3,
        speed: 500,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.main-categories__slider .swiper-pagination',
            type: 'bullets',
            clickable: true
        }
        ,
        breakpoints: {
            992: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }
    });

    //certificates slider
    if ($(window).width() >= 768) {
        let certificatesSlider = new Swiper('.certificates-slider .swiper-container', {
            loop: false,
            spaceBetween: 30,
            slidesPerView: 2,
            speed: 500,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.certificates-slider .slider-button-next',
                prevEl: '.certificates-slider .slider-button-prev',
            },
            pagination: {
                el: '.certificates-slider .swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                992: {
                  slidesPerView: 3,
                  spaceBetween: 30
                }
              }
        });
    };
    //footer accordeon
    if ($(window).width() < 768) {
        $('.footer__title').on('click', function(e){
            e.preventDefault();
            $(this).parents('.footer__col').toggleClass('expand');
            $(this).siblings('.footer-list').slideToggle();
        });
    }

    //cart click (add products to cart)
    $('#mainElement').on('click', '.cart-action-btn', function (e) {
        $(this).toggleClass('active');
        $('#notifyAddCartContainer').empty();
        let productId = $(this)[0].getAttribute('data-num');
        let productPrice = $(this)[0].getAttribute('data-price');
        let availableCount = $('#productCountAvailable_' + productId).val();
        animateMobileCartButton();
        $.ajax({
            type: 'POST',
            url: '/cart/to/',
            data: {product: productId},
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                console.log(data);
                if ($.isEmptyObject(data.error)) {

                    if(FACEBOOK_PIXEL_ENABLE){
                        if(dataUser){
                            async function sendAddToCartEvent() {
                                const productPriceq = productPrice;
                                const productIds = productId;
                                const email = dataUser.email || '';
                                const phone = dataUser.phone || '';
                                const firstName = dataUser.firstname || '';
                                const lastName = dataUser.lastname || '';

                                const emailHash = await sha256(email);
                                const phoneHash = await sha256(phone);
                                const firstNameHash = await sha256(firstName);
                                const lastNameHash = await sha256(lastName);

                                fbq('track', 'AddToCart', {
                                    value: productPriceq,
                                    currency: 'UAH',
                                    content_type: 'product',
                                    content_ids: [productIds],
                                    user_data: {
                                        em: emailHash,
                                        ph: phoneHash,
                                        fn: firstNameHash,
                                        ln: lastNameHash
                                    }
                                });
                            }

                            sendAddToCartEvent();
                        } else {
                            fbq('track', 'AddToCart',
                                {
                                    value: productPrice,
                                    currency: 'UAH',
                                    content_type: 'product',
                                    content_ids: [ productId ]
                                }
                            );
                        }
                    }

                    if('warning' == data.status){
                        addNotification(data.message, data.status);
                    }
                    else{
                        addNotification(PRODUCT_HAS_BEEN_ADDED_TO_YOUR_CART);
                    }

                    $('#cartCount').text(data.count);
                    $('#cartCountMobile').text(data.count);
                    if (data.count > 0) {
                        $('#cartHeaderStatus').removeClass('empty');
                    } else {
                        $('#cartHeaderStatus').addClass('empty');
                    }
                    // add to notify
                    /* @TODO - добавление в корзину, решить проблему со скоростью и раскомментировать */
                    // $('#notifyAddCartContainer').append(data.view);

                    $('#productCountAvailable_' + productId).val(availableCount - 1);

                    if($('#blockCheckoutProducts').length){
                        cartUpdateBlocksProductsPrices();

                    }

                }
            }
        });



        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: productData[productId]
        });

    });

    //one click
    $('#mainElement').on('click', '.one-click-action-btn', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('#oneClickSuccess').hide();
        $('#oneClickError').hide();
        $('#oneClickOrder').show();

        $('#popupOneClickContainer').empty();
        $.ajax({
            type: 'GET',
            url: '/catalog/product-short/' + $(this)[0].getAttribute('data-num'),
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                if ($.isEmptyObject(data.error)) {
                    $('#popupOneClickContainer').append(data.view);
                    $('#form-one-click-product').val(data.product);

                    $('#oneClickActionBtn_' + data.product).click();
                }
            }
        });
    });

    //price slider
    if ($( "#products-filter-slider" ).length) {
        let priceSlider = document.getElementById('products-filter-slider');

        noUiSlider.create(priceSlider, {
            start: [150, 850],
            connect: true,
            range: {
                'min': 0,
                'max': 1000
            },
            step: 10,
        });
        priceSlider.noUiSlider.on('slide', function () {
            $('.products-filter__price--from input').val(Math.round($('.noUi-handle-lower').attr('aria-valuenow')));
            $('.products-filter__price--to input').val(Math.round($('.noUi-handle-upper').attr('aria-valuenow')));
        });
        $('.products-filter__price--from input').on('input', function () {
            priceSlider.noUiSlider.set([$(this).val(), null]);
        });
        $('.products-filter__price--to input').on('input', function () {
            priceSlider.noUiSlider.set([null, $(this).val()]);
        });
    }
    //filter expand block
    $('.products-filter-block__title').on('click', function (e) {
        e.preventDefault();
        if ($(this).find('.products-filter-block__title-icon').text() == "+")
            $(this).find('.products-filter-block__title-icon').text("-")
        else
            $(this).find('.products-filter-block__title-icon').text("+");
        $(this).siblings('.products-filter-block__bottom').slideToggle();
    });
    // $('.products-filter-block__title').click();
    //custom select
    $('.products-page__sort-block select').wSelect();
    $('.pagination-nav-view__list-mob').wSelect();
    $('.checkout-delivery__post-office select').wSelect();
    $('.sales-page__select select').wSelect();
    $('.brands-nav-left-select select').wSelect();
    $('.personal-data-form__select select').wSelect();
    $('.brands-nav-select select').wSelect();
    $('.stores-page-left-select select').wSelect();

    // //products popup slider
    // Fancybox.bind(".product-details__photos-big", {
    //     on: {
    //       done: (fancybox, slide) => {
    //         let productPopupLeft = new Swiper('.product-details-popup__photos-small', {
    //             slidesPerView: 7,
    //             spaceBetween: 10,
    //             watchSlidesVisibility: true,
    //             watchSlidesProgress: true,
    //             direction: 'vertical',
    //         });
    //         let productsPopupRight = new Swiper('.product-details-popup__photos-big', {
    //             zoom: true,
    //             thumbs: {
    //                 swiper: productPopupLeft
    //             },
    //             navigation: {
    //                 nextEl: '.product-details-popup__photos-big-wrapper .slider-button-next',
    //                 prevEl: '.product-details-popup__photos-big-wrapper .slider-button-prev',
    //             },
    //             pagination: {
    //                 el: '.product-details-popup__photos-big-wrapper .swiper-pagination',
    //                 type: 'bullets',
    //                 clickable: true
    //             }
    //         });
    //       },
    //     },
    //     dragToClose: false
    //   });

    // //products slider
    // let productLeft = new Swiper('.product-details__photos-small', {
    //     slidesPerView: 7,
    //     spaceBetween: 10,
    //     watchSlidesVisibility: true,
    //     watchSlidesProgress: true,
    //     direction: 'vertical',
    // });
    let productsRight = new Swiper('.product-details__photos-big', {
        // thumbs: {
        //     swiper: productLeft
        // },
        navigation: {
            nextEl: '.product-details__photos-big-wrapper .slider-button-next',
            prevEl: '.product-details__photos-big-wrapper .slider-button-prev',
        },
        pagination: {
            el: '.product-details__photos-big-wrapper .swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });

    //product together slider
    function disableProductTogetherSlider() {
        $('.product-together-section .swiper-container').addClass("disabled");
        $('.product-together-section .swiper-wrapper').addClass("disabled");
        $('.product-together-section .swiper-pagination').addClass("disabled");
        $('.product-together-section .product-together-section__btn-next').addClass("disabled");
        $('.product-together-section .product-together-section__btn-prev').addClass("disabled");
    }
    if ($(".product-together-section .swiper-slide").length <= 1) {
        disableProductTogetherSlider();
    } else {
        let productTogetherSlider = new Swiper('.product-together-section .swiper-container', {
            loop: true,
            spaceBetween: 17,
            slidesPerView: 1,
            pagination: {
                el: '.product-together-section .swiper-pagination',
                clickable: 'true'
            },
            navigation: {
                nextEl: '.product-together-section .product-together-section__btn-next',
                prevEl: '.product-together-section .product-together-section__btn-prev'
            }
        });
    }
    //product details features
    $('.product-details__feature-title').on('click', function(e){
        $(this).siblings('.product-details__feature-details').slideToggle();
        $(this).toggleClass('expand');
    });
    //product details schedule accordeon
    $('.product-details-delivery-shops__title').on('click', function(e){
        e.preventDefault();
        $(this).siblings('.product-details-delivery-shops-list').slideToggle();
        $(this).toggleClass('expand');
    });
    //input animation
    $('#mainElement').on('focus', '.form-field input, .form-field textarea', function(){
        $(this).parents('.form-field').addClass('focused');
      });

      $('#mainElement').on('blur', '.form-field input, .form-field textarea', function(){
        let inputValue = $(this).val();
        if ( inputValue == "" ) {
          if($(this).hasClass('required')){
            $(this).parents('.form-field').removeClass('success');
            $(this).parents('.form-field').addClass('error');
          }
          $(this).parents('.form-field').removeClass('focused');
        } else {
            if($(this).hasClass('required')){
                $(this).parents('.form-field').addClass('success');
                $(this).parents('.form-field').removeClass('error');
            }
        }
    });

    //stars rating count
    $('.rate-block__stars').on('click', function(e){
        let allStars = document.querySelectorAll('.rate-block__star');
        let activeStar;
        let allstarsArray = [...allStars];
        let inputStars = document.querySelector('.rate-block__count');
        allstarsArray.map((el) => {
            if(el.classList.contains('active')){
                return el.classList.remove('active');
            };
        });
        if(e.target.classList.contains('rate-block__star')){
            e.target.classList.add('active');
            allstarsArray.forEach((el, i) => {
                if(el.classList.contains('active')){
                    activeStar = i;
                    inputStars.value = activeStar + 1;
                }
            });
            allstarsArray.map((el, i) => {
                if(i < activeStar){
                    return el.classList.add('active');
                } else {
                    return el;
                }
            })
        }
    });

    //show/hide leave feedback form
    $('.leave-feedback-toogle').on('click', function(e){
        e.preventDefault();
        $('.leave-feedback').slideToggle();
    });

    $('.leave-feedback__close').on('click', function(e){
        e.preventDefault();
        $(this).parents('.leave-feedback').slideUp();
    });

    // show/hide answer form
    $('.product-comment__answer-btn').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('expand');
        $(this).parents('.product-comment').find('.product-comment-reply-form').toggle();
    })
    //like button
    $('.product-comment-mark__button').on('click', function(e){
        e.preventDefault();
        let currentValue = parseInt($(this).find('.product-comment-mark__value').text(), 10);
        let siblingValue = parseInt($(this).siblings().find('.product-comment-mark__value').text(), 10);
        if ($(this).siblings().hasClass('userlike')){
            $(this).siblings().removeClass('userlike');
            if(siblingValue == 1){
                $(this).siblings().removeClass('active');
            }
            $(this).siblings().find('.product-comment-mark__value').text(--siblingValue);
        }
        if(!$(this).hasClass('userlike')){
            if(currentValue == 0){
                $(this).addClass('active');
            }
            $(this).find('.product-comment-mark__value').text(++currentValue);
        } else{
            if(currentValue == 1){
                $(this).removeClass('active');
            }
            $(this).find('.product-comment-mark__value').text(--currentValue);
        }
        $(this).toggleClass('userlike');
    });
    //filter mobile
    let filterLink = $('.products-page-top__filter-btn');
    $('body').on('click', function (e) {
        if (e.target.classList.contains('page-overlay') || e.target.classList.contains('products-sidebar__close')
            || e.target.parentElement.classList.contains('products-sidebar__close')) {
            $('.page-overlay').removeClass('show');
            $('.products-sidebar').removeClass('active');
            $('body').removeClass('overflow');
        }
    });
    filterLink.on('click', function (e) {
        e.preventDefault();
        $('.page-overlay').addClass('show');
        $('.products-sidebar').addClass('active');
        $('body').toggleClass('overflow');
    });
    // products catalog sidebar
    $('.products-sidebar-catalog a').each(function() {
        if ($(this).next('ul').length > 0) {
            $(this).addClass('has-submenu');
        }
    });
    $('.products-sidebar-catalog .has-submenu').on('click', function(e){
        e.preventDefault();
        $(this).siblings().slideToggle();
        $(this).toggleClass('open');
    })
    //checkout tabs
    $(".checkout-data__tab").click(function() {
        $(".checkout-data__tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".checkout-data__tab-item").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");
    //personal account tabs
    $(".personal-account-tab").click(function() {
        $(".personal-account-tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".personal-account-tabs-item").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");
    //delivery method accordion
    $('.checkout-delivery__item-top input').change(function() {
        if($(this).is(':checked')){
            $(this).closest('li').siblings().removeClass('active').find('.checkout-delivery__item-bottom').slideUp(250);
            $(this).closest('li').addClass('active').find('.checkout-delivery__item-bottom').slideDown(250);
        }
    });
    //checkout show comment
    $('.checkout__add-comment-btn').on('click', function(e){
        e.preventDefault();
        $(this).hide();
        $(this).siblings().show();
    });

    $('.block_collapse__title').on('click', function(e) {
        e.preventDefault();
        // Найти родительский контейнер с классом 'block_collapse'
        const parentBlock = $(this).closest('.block_collapse');
        // Переключить класс 'collapse' у заголовка
        $(this).toggleClass('collapse');
        // Найти список <ul> внутри родительского контейнера и переключить его видимость
        const targetList = parentBlock.find('ul');
        // Проверить, найден ли нужный элемент
        if(targetList.length) {
            targetList.toggle("fade");
        } else {
            console.log("Элемент <ul> не найден внутри блока 'block_collapse'. Проверьте правильность селекторов.");
        }
    });



    //header side cart
    $('.header-bottom-link--cart').on("click", function(e){
        e.preventDefault();
        if(!$(this).hasClass('empty')){
            $('.aside-cart').addClass('active');
            $('body').addClass('overflow');
            $('.page-overlay').addClass('show');
        }
        else if($(this).hasClass('empty')){
            $(this).parents('.header-cart').toggleClass('active');
        }
    });
    $('body').on('click', function(e){
        if ($('.aside-cart').hasClass('active')) {
            if ($('.page-overlay').is(e.target) || $('.aside-cart__close').is(e.target)) {
                $('.page-overlay').removeClass('show');
                $('body').removeClass('overflow');
                $('.aside-cart').removeClass('active');
            }
        }
        if ($('.header-cart').hasClass('active')) {
            if (!$('.empty-cart').is(e.target) && $('.empty-cart').has(e.target).length === 0 &&
                !$('.header-bottom-link--cart').is(e.target) && $('.header-bottom-link--cart').has(e.target).length === 0) {
                $('.header-cart').removeClass('active');
            }
        }
    });

    //sales page select
    if($(window).width() <= 1200){
        $('.sales-page__tabs-top').on('click', function(e){
            e.preventDefault();
            $('.sales-page__tabs').toggleClass('active');
        })
        $('.sales-page__tabs .sales-page__tab').on('click', function(e){
            e.preventDefault();
            let selectedElement = $(this).clone();
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $(this).parents('.sales-page__tabs-wrapper').find('.sales-page__tabs-top').html(selectedElement);
            $(this).parents('.sales-page__tabs').removeClass('active');
        });
    }
    //personal account accordion
    $('.personal-account-accordion__top').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).siblings('.personal-account-accordion__bottom').slideToggle();
    })

    //datepicker
    $('.personal-data-form__date input').datepicker({
        onSelect: function(){
            $(this).parents('.form-field').addClass('focused');
        }
    });
    $('.personal-data-form__date-btn').on('click', function(e){
        e.preventDefault();
        $('.personal-data-form__date input').datepicker('show');
    });

    //personal account data form
    $('.personal-data-form__edit-btn').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-data-form-constant').hide();
        $('.personal-data-form-edit').show();
    });
    $('.personal-data-form__save-btn, .personal-data-form__cancel-btn').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-data-form-edit').hide();
        $('.personal-data-form-constant').show();
    });
    //personal account add address
    $('.personal-data-accordion-address__add').on('click', function(e){
        e.preventDefault();
        let addressForm = `
            <form class="personal-data-accordion-address__form">
                <div class="form-field">
                    <input type="text">
                    <span class="placeholder">Місто</span>
                </div>
                <div class="form-field disabled">
                    <input type="text" disabled>
                    <span class="placeholder">Вулиця</span>
                </div>
                <div class="form-field disabled">
                    <input type="text" disabled>
                    <span class="placeholder">Будинок</span>
                </div>
                <div class="form-field disabled">
                    <input type="text" disabled>
                    <span class="placeholder">Квартира</span>
                </div>
                <a href="#" class="del"><span class="del__icon"></span><span class="del__name">Видалити адресу</span></a>
            </form>
        `;
        $(this).parents('.personal-account-accordion__bottom').prepend(addressForm);
    });

    //personal account orders accordion
    $('.personal-account-order__top').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-account-order').toggleClass('active');
        $(this).siblings('.personal-account-order__bottom').slideToggle();
    });

    //personal account history accordion
    $('.personal-account-history__top').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-account-history').toggleClass('active');
        $(this).siblings('.personal-account-order__bottom').slideToggle();
    });
    //personal account wishlist button
    $('.personal-account-wishlist-table__btn').on('click', function(e){
        e.preventDefault();
        $(this).parent('.personal-account-wishlist-table__btn-wrapper').toggleClass('active');
    })

    $('body').on('click', function (e) {
        if ($('.personal-account-wishlist-table__btn-wrapper').hasClass('active')) {
            if (!$('.personal-account-wishlist-table__btn').is(e.target) && $('.personal-account-wishlist-table__btn').has(e.target).length === 0) {
                $('.personal-account-wishlist-table__btn-wrapper').removeClass('active');
            }
        }
    });
    //personal account reviews accordion
    $('.personal-account-review-header').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-account-review').toggleClass('active');
        $(this).siblings('.personal-account-review-main').slideToggle();
    });
    //personal account laptop menu
    $('.personal-account-tabs-field').on('click', function(e){
        e.preventDefault();
        $(this).parents('.personal-account-content').toggleClass('shrink');
    });
    //personal account mob menu
    $('.personal-account-menu-btn').on('click', function(e){
        e.preventDefault();
        $('.personal-account-tabs-wrapper').addClass('active');
        $('body').addClass('overflow');
    });
    $('.personal-account-tabs-header__close, .personal-account-tab').on('click', function(e){
        e.preventDefault();
        $('.personal-account-tabs-wrapper').removeClass('active');
        $('body').removeClass('overflow');
    });
    //categories select
    $('.categories-select-top').on('click', function(e){
        e.preventDefault();
        $(this).siblings('.categories-select-bottom').toggleClass('active');
    })
    $('.categories-select-bottom li').on('click', function(e){
        e.preventDefault();
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        let selectedElement = $(this).clone();
        $(this).parents('.categories-select-wrapper').find('.categories-select-top').html(selectedElement);
        $(this).parents('.categories-select-bottom').removeClass('active');
    });
    //stores tabs
    $(".stores-page-tab").click(function() {
        $(".stores-page-tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".stores-page-tab-item").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");
    //stores slider
    const storesSlider = new Swiper('.stores-detail-slider .swiper-container', {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 500,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.stores-detail-slider .slider-button-next',
            prevEl: '.stores-detail-slider .slider-button-prev',
        },
    });
    //accordion
    $('.accordion-top').on('click', function(){
        $(this).toggleClass('active');
        $(this).siblings('.accordion-bottom').slideToggle();
    });

    function productPopupMessage(message, status){
        $('#popup-product-message').addClass('active');
        $('#popup-product-message').addClass(status);
        $('.popup-product-message-html').html(message);
        setTimeout(function(){
            $('#popup-product-message').removeClass('active');
        }, 5000);
    }

    //add to cart popup - detail
    $('#mainElement').on('click', '.product-details__cart-btn', function(e){
        e.preventDefault();
        productPopupAdded();
    });

    $('.item-added-popup__close').on('click', function(e){
        e.preventDefault();
        $('.item-added-popup').removeClass('active');
    });

    //add wishlist popup
    $('.add-wishlist-page-popup .input-wrapper input').on('input', function(e){
        if($(this).val()){
            $(this).parents('.add-wishlist-page-popup').find('.add-wishlist-page-popup__btn').addClass('active');
        }
        else{
            $(this).parents('.add-wishlist-page-popup').find('.add-wishlist-page-popup__btn').removeClass('active');
        }
    });
    //search popup
    $('.header-search input').on('input', function(){
        if($(this).val()){
            $('.search-popup').addClass('active');
            $('.header-search__clear').addClass('active');
            $('body').addClass('overflow');
            $('.page-overlay-small').addClass('show');
        }
        else {
            $('.search-popup').removeClass('active');
            $('.header-search__clear').removeClass('active');
            $('body').removeClass('overflow');
            $('.page-overlay-small').removeClass('show');
        }
    });
    $('.header-search__clear').on('click', function(e){
        console.log(' some click header-search__clear');
        e.preventDefault();
        $('#searchInput').val('');
        $('.search-popup').removeClass('active');
        $('.header-search__clear').removeClass('active');
        $('body').removeClass('overflow');
        $('.page-overlay-small').removeClass('show');
    });
    $('body').click(function (e) {
        console.log(' click body ');
        if ($('.search-popup').hasClass('active')) {
            console.log(' and > earch-popup hasClass active ');
            if (!$('.search-popup').is(e.target) && $('.search-popup').has(e.target).length === 0 && !$('.header-search-wrapper').is(e.target)
                && $('.header-search-wrapper').has(e.target).length === 0) {
                    console.log(' and > continue if ');
                // $('.header-search input').val('');
                // $('.header-search__clear').removeClass('active');
                $('.search-popup').removeClass('active');
                $('body').removeClass('overflow');
                if(!$('.header-catalog__btn').is(e.target) && $('.header-catalog__btn').has(e.target).length === 0){
                    $('.page-overlay-small').removeClass('show');
                }
            }
        }
    });
    $('#oneClickOrder .btn-yellow').on('click', function(){
        $(this).closest("#oneClickOrder").hide();
        $(this).closest("#oneClickOrder").siblings('#oneClickSuccess').show();
    });

    $(document).on('click', '.bottom-nav-catalog-main .header-catalog-link', function(e){
        $(this).parents('.bottom-nav-catalog-main').hide();
        $(this).parents('.bottom-nav-catalog-main').siblings('.bottom-nav-catalog-sub').show();
    });

    $(document).on('click', '.bottom-nav-catalog-sub__title', function(e){
        e.preventDefault();
        $(this).parents('.bottom-nav-catalog-sub').hide();
        $(this).parents('.bottom-nav-catalog-sub').siblings('.bottom-nav-catalog-main').show();
    });

    $(document).on('click', '.bottom-nav__close', function(e){
        e.preventDefault();
        $('body').removeClass('overflow');
        $(this).parents('.bottom-nav__block').removeClass('active');
        $('.bottom-nav__tab').removeClass('active');
    });
});

function animateMobileCartButton(){
    // Зміна фонового кольору на червоний плавно протягом 5 секунд
    $('#bottomNavCartButton').css({ backgroundColor: '#fc0' });

    // Після 5 секунд плавно повертаємо до початкового кольору
    setTimeout(function() {
        $('#bottomNavCartButton').css({ backgroundColor: '#fff' }); // Повернення за 1 секунду
    }, 3000);
}

function productPopupAdded(){
    $('#popup-product-added').addClass('active');
    setTimeout(function(){
        $('#popup-product-added').removeClass('active');
    }, 5000);
}
